import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  private cookieValue: string;

  constructor(
    private translate: TranslateService, private cookieService: CookieService) { 
      this.translate.setDefaultLang('en');
    }

  ngOnInit() {
    this.cookieValue = this.cookieService.get('sessionLocale');
    this.translate.use(this.cookieValue);
  }
}
